// Mirror of the server-side policy in
// backend/TurbineAPI/Services/AuthService.cs -> EnsurePasswordStrength.
// The server is the authority; this exists only so the user gets told before a round trip.
// Keep the two in sync — a client rule stricter than the server locks out valid passwords,
// a looser one just yields an InvalidPassword response.

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_HINT =
    `密码至少 ${PASSWORD_MIN_LENGTH} 位，且需包含大写字母、小写字母和特殊字符`;

const hasUpper = (value) => /[A-Z]/.test(value);
const hasLower = (value) => /[a-z]/.test(value);
// Matches the server's !char.IsLetterOrDigit: anything that is not an ASCII/Unicode
// letter or digit counts as special.
const hasSpecial = (value) => /[^\p{L}\p{N}]/u.test(value);

export const isPasswordAcceptable = (password) =>
    typeof password === "string"
    && password.length >= PASSWORD_MIN_LENGTH
    && hasUpper(password)
    && hasLower(password)
    && hasSpecial(password);
